import { Component, ReactNode } from 'react';
import { NavLink, useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { AdminApi } from '../admin-api';
import Header from './Header';
import PageLoading from './PageLoading';
import Sidebar from './Sidebar';

export default function People(props: any): ReactNode {
  return <PeopleComp navigate={useNavigate()} {...props} />;
}

class PeopleComp extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser?: any;
    }>,
  ) {
    super(props);
    this.state = {
      isLoading: true,
      list: [],
    };
  }

  state: Readonly<{
    isLoading: boolean;
    list: any[];
  }>;

  async changeStatus(e: any, user: any) {
    e.preventDefault();
    const _url = user.isActive ? 'inactivate' : 'reactivate';
    await AdminApi.put(`/users/${user.id}/${_url}`, {});

    user.isActive = !user.isActive;
    this.setState({ list: this.state.list });

    toast.success('Status alterado com sucesso');
  }

  async componentDidMount(): Promise<void> {
    const _data = await AdminApi.get('/users');
    this.setState({ isLoading: false, list: _data });
  }

  render(): ReactNode {
    return this.state.isLoading ? (
      <PageLoading />
    ) : (
      <div>
        <Header
          navigate={this.props.navigate}
          currentUser={this.props.currentUser}
        ></Header>
        <div className="container-fluid">
          <div className="row">
            <Sidebar
              navigate={this.props.navigate}
              currentUser={this.props.currentUser}
            ></Sidebar>
            <main className="ms-sm-auto px-md-4 large-calendar">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">Pessoas</h1>
                <div className="btn-toolbar mb-2 mb-md-0">
                  <div className="btn-group me-2">
                    <NavLink
                      to="/people/new"
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                    >
                      Adicionar pessoa
                    </NavLink>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-3">
                <table className="table table-striped table-hover table-bordered">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>E-mail</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    {this.state.list.map((item) => (
                      <tr key={item.id}>
                        <td>{item.name}</td>
                        <td>{item.email}</td>
                        <td>
                          {item.isActive ? (
                            <span className="badge bg-primary">Ativo</span>
                          ) : (
                            <span className="badge bg-secondary">Inativo</span>
                          )}
                        </td>
                        <td>
                          <a href={`/admin/people/${item.id}/edit`}>Editar</a>
                          <a
                            style={{ marginLeft: '1rem' }}
                            href="#"
                            onClick={(e: any) => this.changeStatus(e, item)}
                          >
                            {item.isActive ? 'Desativar' : 'Reativar'}{' '}
                          </a>
                          <a
                            style={{ marginLeft: '1rem' }}
                            href={`/admin/people/${item.id}/password`}
                          >
                            Alterar senha
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
